import { render } from "./Modal.vue?vue&type=template&id=5e96562e"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/System/Compenents/Modal/Modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e96562e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e96562e', __exports__)) {
    api.reload('5e96562e', __exports__)
  }
  
  module.hot.accept("./Modal.vue?vue&type=template&id=5e96562e", () => {
    api.rerender('5e96562e', render)
  })

}


export default __exports__